import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveDressingAsync, setIsMessageShowForSecondayDressing, getlistOptionsAsync, getDressingAsync } from "../../../../../app/patientSlice";
import { useParams } from "react-router-dom";
import { useTreatmentBase } from "./useTreatmentBase";

export const useSecondaryDressing = ({ interventionId, formularyId }) => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();

  const isMessageShowForSecondayDressing = useSelector((state) => state.patient.isMessageShowForSecondayDressing);

  const { editData, viewData: rawViewData } = useTreatmentBase({
    interventionId,
    formularyId,
    payType: "secondarydressing",
    listOptionsSelector: (s) => s.patient.secondaryDressingListOptions,
    getDataSelector: (s) => s.patient.secondaryDressingGetData,
  });

  const [closeWarning, setCloseWarning] = useState(false);
  const [saveDataConfirm, setSaveDataConfirm] = useState("");
  const [dropValue, setDropValue] = useState(false);
  const [secSelectData, setSecSelect] = useState([]);

  useEffect(() => {
    setSaveDataConfirm("");

    if (!Array.isArray(rawViewData) || !Array.isArray(editData)) {
      setSecSelect([]);
      return;
    }

    const optionsMap = {};
    editData.forEach((item) => {
      item?.options?.forEach((opt) => {
        if (opt?.materialNumber) {
          optionsMap[opt.materialNumber] = opt.isRecommended;
        }
      });
    });

    setSecSelect(
      rawViewData
        .filter((item) => optionsMap[item?.value] !== undefined)
        .map((item) => ({
          key: item?.key,
          value: item?.value,
          isRecommended: optionsMap[item.value],
        }))
    );
  }, [rawViewData, editData]);

  useEffect(() => {
    dispatch(setIsMessageShowForSecondayDressing({}));
  }, [dispatch]);

  const saveData = useCallback(
    (data) => {
      const payloadData = {
        productCategory: data,
        patientId,
        assessmentId,
        interventionId,
        payType: "secondarydressing",
        formularyId,
      };

      setSaveDataConfirm(payloadData);
      const shouldWarn = isMessageShowForSecondayDressing === 1;
      setCloseWarning(shouldWarn);

      if (!shouldWarn) {
        dispatch(saveDressingAsync(payloadData));
      }
    },
    [dispatch, patientId, assessmentId, interventionId, formularyId, isMessageShowForSecondayDressing]
  );

  const yesFn = useCallback(() => {
    dispatch(saveDressingAsync(saveDataConfirm));
    dispatch(setIsMessageShowForSecondayDressing({}));
    setCloseWarning(false);
    setDropValue(false);
  }, [dispatch, saveDataConfirm]);

  const noFn = useCallback(() => {
    setSaveDataConfirm("");
    setCloseWarning(false);
    dispatch(getlistOptionsAsync({ formularyid: formularyId, option: "secondarydressing", payType: "secondarydressing" }));
    dispatch(getDressingAsync({ patientId, assessmentId, interventionId, payType: "secondarydressing" }));
  }, [dispatch, formularyId, patientId, assessmentId, interventionId]);

  return {
    editData,
    secSelectData,
    closeWarning,
    dropValue,
    setDropValue,
    setCloseWarning,
    saveData,
    yesFn,
    noFn,
  };
};
